import { handleResponse, handleError, headerset } from "../apiUtils";
import { Allegato } from "../../components/allegati/allegatiSlice";
import { toast } from "react-toastify";

const baseUrl = (
	ordine_id?: number | null,
	pagamento_id?: number | null,
	tipo_documento_id?: number | null
) => {
	let baseUrl = process.env.API_URL + "/api/allegati/allegati_list/";
	if (ordine_id || pagamento_id || tipo_documento_id) {
		baseUrl += "?";
		if (ordine_id) {
			baseUrl += `ordine=${ordine_id}&`;
		}
		if (pagamento_id) {
			baseUrl += `pagamento=${pagamento_id}&`;
		}
		if (tipo_documento_id) {
			baseUrl += `tipo_documento=${tipo_documento_id}&`;
		}
	}
	return baseUrl;
};

export function fetchAllegati(
	ordine_id?: number | null,
	pagamento_id?: number | null,
	tipo_documento_id?: number
) {
	return fetch(baseUrl(ordine_id, pagamento_id, tipo_documento_id), {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json",
			Authorization: headerset().Authorization,
		},
	})
		.then(handleResponse)
		.catch(handleError);
}

export function deleteAllegato(allegatoToDelete: Allegato) {
	const url =
		process.env.API_URL + "/api/allegati/allegato/" + allegatoToDelete.id + "/";
	return fetch(url, {
		method: "DELETE",
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json",
			Authorization: headerset().Authorization,
		},
	})
		.then(handleResponse)
		.catch(handleError);
}

const uploadBaseUrl = (
	nomeFile: string,
	descrizione?: string,
	tipo_documento?: number | null,
	ordine_id?: number | null,
	pagamento_id?: number | null
) => {
	let uploadBaseUrl = process.env.API_URL + "/api/allegati/upload/";
	if (pagamento_id) {
		uploadBaseUrl += `pagamento/${pagamento_id}/${nomeFile}`;
	} else if (ordine_id) {
		uploadBaseUrl += `ordine/${ordine_id}/${nomeFile}`;
	} else {
		toast.error("Errore: manca il riferimento al pagamento o all'ordine");
		return "";
	}
	if (descrizione) {
		uploadBaseUrl += "?descrizione=" + descrizione;
		tipo_documento && (uploadBaseUrl += "&tipo_documento=" + tipo_documento);
	} else {
		tipo_documento && (uploadBaseUrl += "?tipo_documento=" + tipo_documento);
	}

	return uploadBaseUrl;
};

export function uploadAllegato(
	allegato: Allegato,

	file: File
) {
	return fetch(
		uploadBaseUrl(
			file.name,
			allegato.descrizione,
			allegato.tipo_documento,
			allegato.ordine,
			allegato.pagamento
		),
		{
			method: "PUT", // PUT to upload.
			headers: {
				"content-type": "application/json",
				Authorization: headerset().Authorization,
			},
			body: file,
		}
	)
		.then(handleResponse)
		.catch(handleError);
}

export function mandaDocumentiLotto(lotto_id: number, contatto_id: number) {
	const url =
		process.env.API_URL +
		"/api/allegati/manda_documenti_lotto/" +
		lotto_id +
		"/" +
		contatto_id +
		"/";

	return fetch(url, {
		method: "PUT", // PUT to upload.
		headers: {
			"content-type": "application/json",
			Authorization: headerset().Authorization,
		},
	})
		.then(handleResponse)
		.catch(handleError);
}

// #######################################################################

export function avvertiUtenteDocumentiLotto(
	lotto_id: number,
	utenteEsterno_id: number
) {
	const url =
		process.env.API_URL +
		"/api/allegati/avverti_utente_documenti_lotto/" +
		lotto_id +
		"/" +
		utenteEsterno_id +
		"/";

	return fetch(url, {
		method: "PUT", // PUT to upload.
		headers: {
			"content-type": "application/json",
			Authorization: headerset().Authorization,
		},
	})
		.then(handleResponse)
		.catch(handleError);
}

// #######################################################################

const tipiDocumentoUrl =
	process.env.API_URL + "/api/allegati/tipo_documento_list/";

export function fetchTipiDocumento() {
	return fetch(tipiDocumentoUrl, {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json",
			Authorization: headerset().Authorization,
		},
	})
		.then(handleResponse)
		.catch(handleError);
}
